import { useEffect, useState } from "react";

function useMobileView() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 767;
      setIsMobile((prev) => {
        if (prev !== isNowMobile) {
          return isNowMobile;
        }
        return prev;
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isMobile };
}

export default useMobileView;
